import { SyntheticEvent } from 'react';
import styled from 'styled-components';

type Props = {
  tags: {
    name?: string;
    shortName?: string;
    entityName?: string;
    slug?: string;
    entityId?: number;
    id?: number;
  }[],
  onClick?: (slug: string, id?: number) => void,
}

export default function HealthTags({ tags, onClick }: Props) {
  if (tags.length === 0) return null;

  const onTagClick = (e: SyntheticEvent, slug: string, id?: number) => {
    if (onClick) {
      e.preventDefault();
      onClick(slug, id);
      // delay redirection to be able to send tracking event
      setTimeout(() => {
        window.location.href = `/tag/${slug}`;
      }, 100);
    }
  };

  return (
    <ul className="button-tags">
      {tags.map(tag => {
        const tagName = tag.name || tag.shortName || tag.entityName;
        return (
          <li key={tag.slug || tagName}>
            <TagLink
              className="button-tag"
              data-testid="button-tag"
              href={`/tag/${tag?.slug}`}
              onClick={e => onTagClick(e, tag?.slug, (tag.entityId || tag.id))}
            >
              {tagName}
            </TagLink>
          </li>
        );
      })}
    </ul>
  );
}

const TagLink = styled.a`
  color: ${props => props.theme.colorBlack};
  font-size: ${props => props.theme.fontSizeS};
`;
